export const occupationalProfile = {
  id: 2651,
  status: 0,
  original_name: "BBC LEVEL EXE'24",
  holland: "Enterprising and Social",
  ciss: "4433-Inspirational",
  mbti: "ENTP-Inventor",
  area: "Level Executive (CORP SRLD'12'19'24), N=30",
  cumulative_sd: 1.4,
  ex: 7.1,
  an: 3.7,
  tm: 4.9,
  in: 6.4,
  sc: 5.2,
  a: 6.4,
  b: 7.9,
  c: 7.1,
  e: 6.2,
  f: 6.4,
  g: 5.7,
  h: 7.2,
  i: 5.3,
  l: 3.7,
  m: 5.2,
  n: 4.7,
  o: 4.5,
  q1: 6.8,
  q2: 3.5,
  q3: 4.9,
  q4: 4.8,
  source_year: "CCG (2024), COMP+",
  default: false,
  original: true,
  hol: false,
  tags: [],
};
